const GET_PRICE_INFO = 'GET_PRICE_INFO';
const SET_PRICE_INFO = 'SET_PRICE_INFO';

export {
    GET_PRICE_INFO,
    SET_PRICE_INFO
};
